<template lang="pug">
.border_tab.d-flex.flex-column.justify-content-around.i_pt_2(
  :class="{ selected: selected }",
  @click="tabClick"
)
  img(:src="productQuestion.area02_ProductList_icon")
  h5.text-center {{ productQuestion.area02_ProductList_Title }}
</template>

<script>
export default {
  name: "BorderTab",
  props: {
    productQuestion: Object,
    selected: Boolean,
  },
  components: {},
  methods: {
    tabClick() {
      this.$router.push({
        name: "ProductIntro",
        params: {
          type: this.productQuestion.ProductJson,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/border_tab";
</style>
